export default __webpack_public_path__ + "static/media/1570.645f216b.png";